import React, { useEffect, useState } from 'react';
import convertMarkdown from '../../lib/markdown/convert-markdown';

interface MarkdownContentProps {
  content: string;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    convertMarkdown(content).then((c) => setMarkdown(c));
  }, [content]);

  return (
    <React.Fragment>
      <div className="content" dangerouslySetInnerHTML={{ __html: markdown }} />
      {/* language=CSS */}
      <style jsx>{`
        .content {
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
          width: 100%;
          display: block;
          font-size: 16px;
        }

        .content :global(h2),
        .content :global(h3),
        .content :global(strong) {
          font-weight: 500;
        }

        .content :global(a) {
          color: #333;
        }

        .content :global(a:hover) {
          color: #707070;
        }
      `}</style>
    </React.Fragment>
  );
};

export default MarkdownContent;
